import React from "react";

const WidgetClienteCoberturaMessage = (props) => {
    return (
        <div className="chat-options-container">
            <p className="react-chatbot-kit-chat-bot-message">
                ¿Cómo deseas validar la cobertura?
            </p>
            <button
                onClick={() => {
                    props.actions.setValidacionCoberturaMetodo("direccion");
                    props.actions.sendBotResponse("Ingresa la direccion de la siguiente manera: calle, numero, colonia");
                }}
                className="chat-option-button"
            >
                Validación por dirección
            </button>
            <button
                onClick={() => {
                    props.actions.setValidacionCoberturaMetodo("codigoPostal");
                    props.actions.sendBotResponse("Ingresa el código postal:");
                }}
                className="chat-option-button"
            >
                Validación por código postal
            </button>
        </div>
    );
};

export default WidgetClienteCoberturaMessage;
